import { map, partial } from 'ramda';
import {
    getBoolParamValue,
    getDoubleParamValue,
    getIntParamValue,
    getParamValue,
} from '../helpers/parameter.accessors';
import makeCustomCommandQueryService from './customCommandQueries';

const paramGetterFunctions = {
    get: getParamValue,
    getBool: getBoolParamValue,
    getInt: getIntParamValue,
    getNumber: getDoubleParamValue,
};

// qRulesParameters -> ParamProvider
const makeParamProvider = (parameters) =>
    map((f) => partial(f, [parameters]), paramGetterFunctions);

// CommandServices -> CustomCommandServices
const buildCustomCommandServices = ({ parameters, peopleSearch }) => ({
    ...makeParamProvider(parameters),
    queries: makeCustomCommandQueryService(peopleSearch),
});

export default buildCustomCommandServices;
